var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"new-user"},[_c('button',{staticClass:"avatar",attrs:{"type":"button"},on:{"click":function($event){return _setup.emit('click')}}},[_c('v-icon',{staticClass:"icon"},[_vm._v(" "+_vm._s(_setup.mdiPlus)+" ")])],1),_c('p',{staticClass:"label"},[_vm._v("Edit "+_vm._s(_vm.userRole))])])
}
var staticRenderFns = []

export { render, staticRenderFns }